import { NotificationEventEnum } from '.'
import { IssueStatus } from '../statuses/issue'
import { NotificationEventItem } from './NotificationEventItem'
import { CommentedNotificationEventItem } from './common/commented'
import { EditedNotificationEventItem } from './common/edited'
import { RevertedNotificationEventItem } from './common/reverted'

const Submitted = new NotificationEventItem({
  id: '1BA4B0B9-2AD3-491B-BA42-21FA7AAC3731',
  name: 'Submitted',
  description: `An issue is sent from ${IssueStatus.Draft.name} to ${IssueStatus.PendingResponse.name}`,
})

const Responded = new NotificationEventItem({
  id: '99459204-FD55-4A5A-9F92-E8A7E7E40426',
  name: 'Responded',
  description: `A response is made to an issue, advancing it to ${IssueStatus.PendingDisposition.name}`,
})

const DispositionGiven = new NotificationEventItem({
  id: '6BA1E0CA-D2ED-4BBC-AFF3-ADB8AE031741',
  name: 'Disposition Given',
  description: `A disposition is submitted for an issue, advancing it to ${IssueStatus.PendingClosure.name}`,
})

const Closed = new NotificationEventItem({
  id: 'A7FEAD6A-0554-4CFF-9BED-B0E2E6889993',
  name: 'Closed',
  description: 'An issue is marked as closed',
})

const Edited = EditedNotificationEventItem({
  id: 'D85227A1-5485-479A-B284-FF206C26E443',
  editable: 'Issue',
})

const Reverted = RevertedNotificationEventItem({
  id: '2299E008-CACE-4AFE-AAF6-BC0CE6165E01',
  from: [
    IssueStatus.Closed,
    IssueStatus.PendingClosure,
    IssueStatus.PendingDisposition,
    IssueStatus.PendingResponse,
  ],
  to: [
    IssueStatus.PendingClosure,
    IssueStatus.PendingDisposition,
    IssueStatus.PendingResponse,
    IssueStatus.Draft,
  ],
  revertable: 'Issue',
})

const Commented = CommentedNotificationEventItem({
  id: '4F048F10-704D-46C7-8D0D-5DD419B56921',
  commentable: 'Issue',
})

export type IssueNotificationEventItem =
  | typeof Submitted
  | typeof Responded
  | typeof DispositionGiven
  | typeof Closed
  | typeof Edited
  | typeof Reverted
  | typeof Commented

class IssueNotificationEnum extends NotificationEventEnum<
  'IssueNotification',
  IssueNotificationEventItem,
  IssueNotificationEventItem['name'],
  IssueNotificationEventItem['id']
> {
  typename = 'IssueNotification' as const
  get values() {
    return [
      this.Submitted,
      this.Responded,
      this.DispositionGiven,
      this.Closed,
      this.Edited,
      this.Reverted,
      this.Commented,
    ]
  }
  readonly Submitted = Submitted
  readonly Responded = Responded
  readonly DispositionGiven = DispositionGiven
  readonly Closed = Closed
  readonly Edited = Edited
  readonly Reverted = Reverted
  readonly Commented = Commented
}

export const IssueNotificationEvent = new IssueNotificationEnum()
